import styled from 'styled-components';

const Logo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: scale-down;
  object-position: center;
`;

const ColourLine = styled.div`
  padding: 0.4rem 0;
`;

export { ColourLine, Logo };
